import classNames from "classnames";
import React, { Fragment, FunctionComponent } from "react";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
// import GotQuestionsBtn from "Shared/GotQuestionsBtn";
import { Mobile, NotMobile } from "Shared/Responsive";
import { DealState } from "Types/state";
import "./ContinueDealHeader.scss";

export interface ContinueDealHeaderProps {
    deal: DealState;
    type: "primary" | "secondary";
}

const ContinueDealHeader: FunctionComponent<ContinueDealHeaderProps & WithTranslation> = ({ deal, type, t }) => {
    const getTitle = (mobile?: boolean) => {
        return mobile || type === "primary" || !(deal && deal.person)
            ? t("ContinueDeal.ContinueDealHeader.yourDeal")
            : t("ContinueDeal.ContinueDealHeader.userDeal", { firstName: deal.person.first_name });
    };

    const renderPrimary = (mobile?: boolean) => {
        return (
            <div className="ContinueDealHeader__wrapper">
                <h1 className="ContinueDealHeader__title">{getTitle(mobile)}</h1>
                <p className="ContinueDealHeader__text">
                    <Trans i18nKey="ContinueDeal.ContinueDealHeader.description" />
                </p>
            </div>
        );
    };

    const renderSecondary = () => {
        return (
            <Fragment>
                <NotMobile>
                    <Fragment>
                        <div className="ContinueDealHeader__wrapper">
                            <h1 className="ContinueDealHeader__title">{getTitle()}</h1>
                            {/* <GotQuestionsBtn className="ContinueDealHeader__got-questions-button" /> */}
                        </div>
                        <div className="ContinueDealHeader__separator" />
                    </Fragment>
                </NotMobile>
                <Mobile>{renderPrimary(true)}</Mobile>
            </Fragment>
        );
    };

    return (
        <div className={classNames("ContinueDealHeader", `ContinueDealHeader--${type}`)}>
            {type === "primary" ? renderPrimary() : renderSecondary()}
        </div>
    );
};

export default withTranslation()(ContinueDealHeader);
